import { render, staticRenderFns } from "./HearderTitle.vue?vue&type=template&id=35ed1044&scoped=true&"
import script from "./HearderTitle.vue?vue&type=script&lang=js&"
export * from "./HearderTitle.vue?vue&type=script&lang=js&"
import style0 from "./HearderTitle.vue?vue&type=style&index=0&id=35ed1044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed1044",
  null
  
)

export default component.exports